const formatDate = (date: string | null): string | null => {
  if (!date) return date;
  return new Date(date).toLocaleDateString('fr-FR');
};

export default formatDate;
